module.exports = __webpack_public_path__ + "img/genius-tag.24b7ab3f.svg";